<template>
  <!-- 店铺信息-案例展示 -->
  <div class="Case-box">
    <div
      class="Case-presentation"
      v-for="(item, index) in listArr"
      :key="index"
    >
      <div class="content">
        <div class="content-top">
          <img
            src="../../../../../../assets/imgs/tx1@3x.svg"
            alt=""
          />
          <p>张xx</p>
          <p class="address">河南 南阳</p>
          <p
            class="star"
            v-for="(item, index) in item.mark"
            :key="index + 10000"
          ></p>
          <p
            class="null"
            v-for="(item, index) in 5 - item.mark"
            :key="index + 100000"
          ></p>
          <span class="service-status">本店服务</span>
          <span class="Buy-status">购买xxxx设计基础版</span>
          <p
            v-for="(item1, index1) in item.EvaluationTag"
            :key="index1"
            class="EvaluationTag"
          >
            {{ item1.name }}
          </p>
        </div>
        <div class="content-con">
          专业高效，价格合理，值得购买，下次有需要还会在这里下单的，专业高效，价格合理，值得购买，下次有需要还会在这里下单的。专业高效，价格合理，值得购买，下次有需要还会在这里下单的。
        </div>
        <div class="content-time">2024年12月12日</div>
      </div>
      <div
        class="button firm-clickable"
        v-if="item.status == 0 && distinguish == 1"
        @click="handelAppeal(item)"
      >
        申诉
      </div>
      <div class="AuditResult" v-if="item.status == 1 && distinguish == 1">
        <p class="title">申诉失败</p>
        <p class="AuditResult-p">正常评论，没有任何不实言论，无法删除评论。</p>
      </div>
    </div>
    <Appeal
      :dialogAppeal="dialogAppeal"
      @handleCloseAppeal="handleCloseAppeal"
      @handleAppeal="handleAppeal"
    ></Appeal>
  </div>
</template>

<script>
import Appeal from "./Appeal.vue";
export default {
  props: {
    listArr: {},
    distinguish: {}, // 区分是店铺编辑 还是帮帮展示  1店铺中使用   2帮帮中使用
  },
  data() {
    return {
      checked: "",
      dialogAppeal: false, //申请弹窗
    };
  },
  watch: {},
  components: {
    // 申诉弹窗
    Appeal,
  },
  created() {},
  methods: {
    // 申诉弹窗取消
    handleCloseAppeal() {
      this.dialogAppeal = false;
    },
    // 申诉弹窗确认
    handleAppeal() {
      this.dialogAppeal = !this.dialogAppeal;
    },
    // 申诉
    handelAppeal(item) {
      this.dialogAppeal = true;
    },
    handelEditCase(item) {
      this.$emit("handelEditCase", item);
    },
  },
};
</script>

<style scoped lang="less">
.Case-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  .Case-presentation:hover {
    box-shadow: 0px 0px 3px 0px rgba(50, 145, 248, 0.8);
  }
  .Case-presentation {
    width: 100%;
    min-height: 120px;
    background: #ffffff;
    box-shadow: 0px 0px 3px 0px rgba(125, 125, 125, 0.5);
    border-radius: 10px;
    margin-bottom: 20px;
    padding: 10px 20px 10px 50px;
    display: flex;
    font-family: PingFangSC-Medium;
    font-weight: 400;
    .content {
      width: 100%;
      .content-top {
        width: 100%;
        height: 28px;
        line-height: 28px;
        margin-top: 5px;
        display: flex;
        position: relative;
        img {
          width: 30px;
          height: 30px;
          position: absolute;
          left: -40px;
        }
        .address {
          margin-left: 20px;
          margin-right: 50px;
        }
        .star {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../../assets/imgs/shoucang@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 5px;
        }
        .null {
          width: 15px;
          height: 14px;
          background-image: url("../../../../../../assets/imgs/shoucang-null@3x.svg");
          background-size: 100% 100%;
          margin: auto 0;
          margin-right: 5px;
        }
        span {
          font-size: 12px;
          color: #999999;
        }
        .service-status {
          margin: 0px 10px 0px 50px;
        }
        .Buy-status {
          margin-right: 50px;
        }
        .EvaluationTag {
          width: 60px;
          height: 20px;
          line-height: 20px;
          background: rgba(97, 144, 232, 0.2);
          border-radius: 5px;
          font-size: 10px;
          color: #409eff ;
          text-align: center;
          margin: auto 0;
          margin-right: 10px;
        }
      }
      .content-con {
        width: 100%;
        min-height: 28px;
        margin: 20px 0 10px 0;
        font-size: 12px;
      }
      .content-time {
        width: 100%;
        height: 14px;
        line-height: 14px;
      }
    }
    .button {
      width: 100px;
      height: 35px;
      line-height: 35px;
      background: #409eff ;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff;
      text-align: center;
      margin: auto;
      margin-left: 30px;
    }
    // 审核结果
    .AuditResult {
      width: 100px;
      min-height: 100px;
      background: #eeeeee;
      border-radius: 5px;
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      .title {
        width: 100%;
        height: 17px;
        line-height: 17px;
        font-size: 14px;
        color: #fe574a;
        text-align: center;
        margin: 10px 0px 10px 0px;
      }
      .AuditResult-p {
        font-size: 12px;
        color: #666666;
        text-align: justify;
        width: 90px;
        margin: 0 auto;
      }
    }
  }
}
</style>
